module.exports = "/src/views/eternal-dev/businesses/gas-station/images/dark/XEro/logo.svg";